module.exports = __webpack_public_path__ + "img/xuanchuan2.a3004611.png";